export const packageName = import.meta.env.PACKAGE_NAME;
export const packageVersion = import.meta.env.PACKAGE_VERSION;
export const isDevelopment = import.meta.env.MODE === 'development';
export const tracerAppToken = import.meta.env.VITE_TRACER_APP_TOKEN;
export const websocketUrl = import.meta.env.VITE_WEBSOCKET_URL;
export const widgetUuid = import.meta.env.VITE_WIDGET_UUID;
export const widgetApi = import.meta.env.VITE_WIDGET_API;
export const widgetHeartbeatMs = import.meta.env.VITE_WIDGET_HEARTBEAT_MS;
export const widgetVkIdAppKey = import.meta.env.VITE_VKID_APP_KEY;
export const widgetUrl = import.meta.env.VITE_WIDGET_URL;
export const widgetVkIdState = import.meta.env.VITE_VKID_STATE;
export const widgetEnableVkIdAutologin = import.meta.env.VITE_ENABLE_VKID_AUTOLOGIN;
